import { CeoLetterInputs } from './CeoLetter';

export const ceoLetterTransformer = (node: any): CeoLetterInputs => {
    return {
        image: node.relationships?.field_callout_image,
        title: node.field_title,
        textContent: node.field_text_content?.value,
        cta: node.field_cta_link?.length > 0 && {
            uri: node.field_cta_link[0].uri,
            title: node.field_cta_link[0].title,
        },
    };
};
